import { PropsWithChildren } from "react";
import { CardAction } from "../shadcn/card";

const StyledCardAction = ({ children }: PropsWithChildren) => {
  return (
    <CardAction className="w-full mb-3 flex flex-col gap-4 self-center justify-self-center items-center justify-center px-6">
      {children}
    </CardAction>
  );
};

export default StyledCardAction;
